module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-psp.jpg?v=1efd8ca9";